<script lang="ts">
	import { Icon } from '@repo/commons/components'

	interface Props {
		totalSteps?: number
		currentStep?: number
	}

	let { totalSteps = 2, currentStep = $bindable(1) }: Props = $props()

	const goBack = () => {
		if (currentStep > 1) {
			currentStep = currentStep - 1
		}
	}
</script>

<div class="steps-container">
	<div class="back-button {currentStep === 1 ? 'disabled' : ''}" onclick={goBack}>
		<div class="back-icon">
			<Icon name="arrowLeft" size="sm" />
		</div>
		<div class="back-text">Back</div>
	</div>
	<div class="step-label">
		Step {currentStep} of {totalSteps}
	</div>
	<div class="step-progress">
		{#each Array(totalSteps) as _, i (i)}
			<div class="step-bar {i < currentStep ? 'active' : 'inactive'}"></div>
		{/each}
	</div>
</div>

<style lang="postcss">
	.steps-container {
		@apply flex w-full flex-col justify-start items-start gap-2;
	}
	.back-button {
		@apply h-6 bg-transparent justify-center items-center gap-2 inline-flex cursor-pointer;
	}
	.back-button.disabled {
		@apply cursor-not-allowed;
	}
	.back-icon {
		@apply w-5 h-5 flex flex-col justify-center items-center inline-flex;
	}
	.back-text {
		@apply text-center text-base font-semibold leading-normal;
	}
	.back-button.disabled .back-icon,
	.back-button.disabled .back-text {
		@apply text-[#003a66]/10;
	}
	.back-button:not(.disabled) .back-icon,
	.back-button:not(.disabled) .back-text {
		@apply text-[#003a66];
	}
	.step-label {
		@apply self-stretch text-[#001526]/90 text-base font-semibold leading-normal;
	}
	.step-progress {
		@apply self-stretch flex justify-start items-start gap-1 inline-flex;
	}
	.step-bar {
		@apply grow shrink basis-0 h-2 rounded;
	}
	.step-bar.active {
		@apply bg-brand;
	}
	.step-bar.inactive {
		@apply bg-[#004980]/5;
	}
</style>
